<template>
  <!-- 首页-数据看板-国内出让人排名-柱状图 -->
	<div ref="myChart" :style="{margin: '0 auto',width: '100%', height: '100%'}"></div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: {
			echartDatas: {
				type: Array,
				default() {
					return []
				}
			}
		},
		components: {
		},
		created() {
		},
		mounted() {
			this.drawChart()
		},
		methods: {
			drawChart() {
				let echartDatas = this.echartDatas
        let yAxisDatas = []
        let seriesDatas = []
        for (let i = echartDatas.length - 1; i >= 0; i--) {
          yAxisDatas.push(echartDatas[i].name)
          seriesDatas.push(echartDatas[i].count)
        }
				// this.$refs.echartBar.removeAttribute("_echarts_instance_");
				// document.getElementById('echartLine').removeAttribute("_echarts_instance_");
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(this.$refs.myChart, 'light')
				// 指定图表的配置项和数据
				let option = {
					title: {
            text: '包头市出让人排名',
            x: 'center',
            y: 0,
            textStyle: {
              fontSize: 18,
              fontWeight: 'normal',
              color: '#ffffff'
            }
          },
          grid: {
            top: '8%',
            left: '3%',
            right: '8%',
            bottom: '6%',
            containLabel: true
          },
          xAxis: {
            show: true,
            type: 'value',
            axisLabel: {
              show: false,
              textStyle: {
                fontSize: 14,
                fontWeight: 'bolder',
                color: '#ffffff'
              }
            },
            splitNumber: 5,
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#D9D9D9',
                width: 0.4
              }
            }
          },
          yAxis: {
            type: 'category',
            data: yAxisDatas,
            // data: [
            //   '你好现在(北京)科技股份有限公司',
            //   '广州友谱网络科技有限公司',
            //   '厦门顺势共识信息科技有限公司',
            // ],
            min: 2,
            axisLabel: {
              formatter: function(params) {
                return params.length > 16 ? params.slice(0, 16) + '...' : params
              },
              textStyle: {
                color: '#ffffff',
                fontStyle: 'normal',
                fontWeight: 'normal',
                // fontFamily: 'sans-serif',
                fontSize: 14
              }
            }
          },
          series: [
            {
              type: 'bar',
              data: seriesDatas,
              // data: [
              //   13, 13, 13, 14, 14, 15, 17, 17, 27, 30, 34, 37, 51, 66, 84, 105, 140, 265, 814, 871
              // ],
              color: '#91cc75',
              label: {
                show: true,
                position: 'right',
                color: '#FFD700',
                fontSize: '12',
                fontWeight: 'normal'
              },
              barWidth: '12'
            }
          ]
				}
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option)
			}
		},
		watch: {
			echartDatas: {
				handler() { // val, oldVal
					// console.log('当数量变化时重新绘制图表')//但是这两个值打印出来却都是一样的
					this.drawChart()
				}
			}
		}
	}
</script>

<style>
</style>
